@if (visible) {
    <div
        class="fixed inset-x-0 bottom-0 z-[1000] flex justify-center px-4 pb-4"
        [attr.data-testid]="testId || null"
    >
        <div
            class="flex w-full max-w-3xl flex-col gap-3 rounded-lg bg-white p-4 shadow-lg ring-1 ring-black/10 sm:flex-row sm:items-center sm:justify-between sm:gap-4"
        >
            <div class="flex items-start gap-3">
                <mat-icon class="mt-0.5 text-primary">cookie</mat-icon>
                <div class="text-sm text-gray-700">
                    <p class="font-medium text-gray-900">
                        {{ 'consent.title' | translate }}
                    </p>
                    <p class="mt-1">
                        {{
                            'consent.message' | translate: { name: tenantName }
                        }}
                    </p>
                </div>
            </div>

            <div class="flex shrink-0 gap-2">
                <button
                    mat-stroked-button
                    type="button"
                    (click)="onDecline()"
                    [attr.data-testid]="testId ? testId + '-decline-btn' : null"
                >
                    {{ 'consent.decline' | translate }}
                </button>
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="onAccept()"
                    [attr.data-testid]="testId ? testId + '-accept-btn' : null"
                >
                    {{ 'consent.accept' | translate }}
                </button>
            </div>
        </div>
    </div>
}
